import type IService from 'application/services/IService';

export const loggingServiceSymbol = 'logger';

export interface IErrorLoggingService extends IService {
  traceException(e: Error): void;
}
